import React from 'react'
import IndexRedirect from './IndexRedirect'

export * from './IndexRedirect'
export default React.memo(IndexRedirect)
